import { Route, Switch } from "react-router-dom";

import AssetCreationPage from "@faire/prototype-playground/workspace/tma/asset-creation";

export function TomMaRoutes() {
  return (
    <Switch>
      <Route path="/tma/asset-creation" component={AssetCreationPage} />
    </Switch>
  );
}

export const slug = "tma";
